import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 10%;\n  width: 25%;\n  height: 50%;\n  border: 2px solid;\n  border-color: ", ";\n  border-top: 0;\n  border-left: 0;\n  transform: translateX(-50%) rotate(45deg);\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 50%;\n  height: 50%;\n  border: 0;\n  border-radius: 1px;\n  transform: translate(-50%, -50%) scale(1);\n  background-color: ", ";\n\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  font-size: ", ";\n  line-height: 1.5;\n  user-select: none;\n  color: ", ";\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n\n      &:hover ", " {\n        border-color: ", ";\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  flex: 1;\n  width: 100%;\n  cursor: pointer;\n\n  &:hover ", " {\n    border-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  background-color: ", ";\n  transition: background-color 180ms;\n\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useCheckbox } from './useCheckbox';
import { Group } from './Group';
var InputWrapper = styled.span(_templateObject());
var Indicator = styled.span(_templateObject2(), themeGet('checkbox.indicator.size'), themeGet('checkbox.indicator.size'), themeGet('checkbox.indicator.border'), themeGet('checkbox.indicator.borderRadius'), themeGet('checkbox.indicator.borderColor'), themeGet('checkbox.indicator.backgroundColor'), function (props) {
  return props.checked && css(_templateObject3(), themeGet('checkbox.indicator.checked.borderColor'), themeGet('checkbox.indicator.checked.backgroundColor'));
}, function (props) {
  return props.disabled && css(_templateObject4(), themeGet('checkbox.indicator.disabled.borderColor'), themeGet('checkbox.indicator.disabled.backgroundColor'));
});
var Input = styled.input(_templateObject5());
var Wrapper = styled.label(_templateObject6(), Indicator, themeGet('checkbox.indicator.hover.borderColor'), function (props) {
  return props.disabled && css(_templateObject7(), Indicator, themeGet('checkbox.indicator.disabled.borderColor'));
});
export var Text = styled.span(_templateObject8(), themeGet('checkbox.text.fontSize'), themeGet('checkbox.text.color'), function (props) {
  return props.disabled && css(_templateObject9(), themeGet('checkbox.text.disabled.color'));
}); // we should change Square and Text to svg, if we want to animate them.

var Square = styled.span(_templateObject10(), themeGet('checkbox.indicator.indeterminate.backgroundColor'), function (props) {
  return props.disabled && css(_templateObject11(), themeGet('checkbox.indicator.indeterminate.disabled.backgroundColor'));
});
var Tick = styled.span(_templateObject12(), themeGet('checkbox.indicator.icon.borderColor'));
export var Checkbox = function Checkbox(_ref) {
  var indeterminate = _ref.indeterminate,
      disabled = _ref.disabled,
      children = _ref.children,
      checked = _ref.checked,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["indeterminate", "disabled", "children", "checked", "name", "value", "onChange"]);

  var _useCheckbox = useCheckbox({
    checked: checked,
    onChange: onChange
  }),
      isChecked = _useCheckbox.isChecked,
      handleChange = _useCheckbox.handleChange;

  return (
    /*#__PURE__*/
    React.createElement(Wrapper, {
      disabled: disabled
    },
    /*#__PURE__*/
    React.createElement(InputWrapper, null,
    /*#__PURE__*/
    React.createElement(Input, _extends({
      type: "checkbox",
      name: name,
      value: value,
      checked: isChecked,
      disabled: disabled,
      onChange: handleChange
    }, rest)),
    /*#__PURE__*/
    React.createElement(Indicator, {
      checked: isChecked,
      disabled: disabled
    }, isChecked ?
    /*#__PURE__*/
    React.createElement(Tick, null) : indeterminate ?
    /*#__PURE__*/
    React.createElement(Square, {
      disabled: disabled
    }) : null)), children &&
    /*#__PURE__*/
    React.createElement(Text, {
      disabled: disabled
    }, children))
  );
};
Checkbox.Group = Group;